import { http } from './config'

export default {

  getAllAudits: () => {
    return http.get('audits')
  },

  getFilteredAudits: (params) => {
    return http.get('audits', {params})
  },

  getFilteredAuditsOrderStep: (params) => {
    return http.get('audits/order_step_audits', {params})
  },

  getFilteredAuditsProduct: (params) => {
    return http.get('audits/product_audits', {params})
  },

  getFilteredAuditsUser: (params) => {
    return http.get('audits/user_audits', {params})
  },

}
